import type { FormThemesCatalog } from "../types/appearance";
import { FALLBACK_FORM_THEMES } from "../lib/forms/appearance";
import { apiRequest } from "./client";

export async function fetchFormThemes(): Promise<FormThemesCatalog> {
  try {
    const body = await apiRequest<unknown>("/api/v1/form-themes", {
      auth: false,
    });

    if (!body || typeof body !== "object") {
      return FALLBACK_FORM_THEMES;
    }

    const record = body as Record<string, unknown>;
    const raw =
      record.data && typeof record.data === "object" ? record.data : body;
    const catalog = raw as FormThemesCatalog;

    if (!Array.isArray(catalog.themes) || catalog.themes.length === 0) {
      return FALLBACK_FORM_THEMES;
    }

    return {
      defaultTheme:
        catalog.defaultTheme?.trim() || FALLBACK_FORM_THEMES.defaultTheme,
      keys: Array.isArray(catalog.keys)
        ? catalog.keys
        : FALLBACK_FORM_THEMES.keys,
      themes: catalog.themes,
    };
  } catch {
    return FALLBACK_FORM_THEMES;
  }
}
